import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { createApiUrl } from '../config/api';

const CalendarContext = createContext();

export const useCalendar = () => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error('useCalendar must be used within CalendarProvider');
  }
  return context;
};

export const CalendarProvider = ({ children }) => {
  const [plannedCourses, setPlannedCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch planned courses
  const fetchPlannedCourses = async () => {
    try {
      const response = await axios.get(createApiUrl('api/calendar?semester=2026 Spring'));

      let courses = [];
      if (Array.isArray(response.data)) {
        courses = response.data;
      } else if (response.data.courses && Array.isArray(response.data.courses)) {
        courses = response.data.courses;
      }

      setPlannedCourses(courses);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching planned courses:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlannedCourses();
  }, []);

  // Add course to calendar
  const addCourse = async (courseCode) => {
    try {
      const response = await axios.post(createApiUrl('api/calendar/add'), {
        course_code: courseCode,
        semester: '2026 Spring'
      });

      // Refresh calendar data
      await fetchPlannedCourses();
      return { success: true };
    } catch (error) {
      console.error('Error adding course:', error);
      return { success: false, error };
    }
  };

  // Remove course from calendar
  const removeCourse = async (courseCode) => {
    try {
      await axios.delete(createApiUrl(`api/calendar/remove?course_code=${courseCode}&semester=2026 Spring`));

      // Update local state
      setPlannedCourses(prev => prev.filter(c => c.class_tag !== courseCode));
      return { success: true };
    } catch (error) {
      console.error('Error removing course:', error);
      return { success: false, error };
    }
  };

  const value = {
    plannedCourses,
    loading,
    addCourse,
    removeCourse,
    refreshCourses: fetchPlannedCourses
  };

  return (
    <CalendarContext.Provider value={value}>
      {children}
    </CalendarContext.Provider>
  );
};